import { render, staticRenderFns } from "./popconfirm.vue?vue&type=template&id=c8d764ae&"
import script from "./popconfirm.vue?vue&type=script&lang=js&"
export * from "./popconfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports